import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { WindowRef } from '../../services/windowRef';
import { BrandService } from '../../services/brand.service';
import {
  LoggedOutEntitlement,
  LoggedOutEntitlementsService,
} from '../../services/logged-out-entitlements.service';

interface UplBannerDetails {
  url: string;
  text: string;
  header: string;
}

@Component({
  selector: 'upl-banner',
  templateUrl: './upl-banner.component.html',
})
export class UplBannerComponent implements OnInit {
  constructor(
    private contentService: ContentService,
    private windowRef: WindowRef,
    private brandService: BrandService,
    private loggedOutEntitlementsService: LoggedOutEntitlementsService
  ) {}

  uplBannerEnabled: boolean = false;
  uplBanner: UplBannerDetails;
  brand: string;

  ngOnInit(): void {
    this.brand = this.brandService.getBrand();

    this.loggedOutEntitlementsService
      .hasEntitlement(LoggedOutEntitlement.uplBanner)
      .then((result) => (this.uplBannerEnabled = result));

    this.contentService.getContent().subscribe((result) => {
      if (!result) {
        return;
      }

      this.uplBanner = result.uplBanner;
    });
  }

  goToLink(url: string): void {
    this.windowRef.openNewWindow(url);
  }
}
